import { combineReducers, Reducer } from 'redux'
import { History } from 'history'
import { connectRouter, RouterAction, RouterState } from 'connected-react-router'
import { globalActions, globalEpic, globalReducer, GlobalState } from './global'
import { combineEpics, Epic } from 'redux-observable'
import { pagesActions, pagesEpics, pagesReducer, PagesState } from './pages'
import { dataActions, dataEpic, dataReducer, DataState } from './data'
import { ActionType, getType } from 'typesafe-actions'
import { userActions } from './global/user/user-actions'
import { catchError } from 'rxjs/operators'
import { errorToast } from '../components/controls/Toaster/Toaster'

const rootActions = {
    dataActions,
    globalActions,
    pagesActions,
}

export type RootActions = ActionType<typeof rootActions> | RouterAction

export interface RootState {
    data: DataState,
    router: RouterState,
    global: GlobalState,
    pages: PagesState,
}

export type RootEpic = Epic<RootActions, RootActions, RootState>

export const createRootReducer = (history: History): Reducer<RootState, RootActions> => {
    const reducer = combineReducers<RootState>({
        data: dataReducer,
        router: connectRouter(history),
        global: globalReducer,
        pages: pagesReducer,
    })
    return (state, action) => reducer(
        action.type === getType(userActions.logout.success) ? undefined : state,
        action
    )
}

export const rootEpic: RootEpic = (action$, state$, dependencies) => combineEpics(
    dataEpic,
    globalEpic,
    pagesEpics,
)(action$, state$, dependencies).pipe(
    catchError((error, source$) => {
        errorToast('Произошла ошибка в одном из эпиков\n Возможны нарушения в работе приложения')
        return source$
    })
)
